import { rootDomain } from '@/src/store/root-domain';
export const domainKey = 'widgets';
export const widgetsDomain = rootDomain.createDomain(domainKey);

export enum WidgetType {
  Platform = 0,
  Dashboard = 1,
  Universal = 2
}
